var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "must-have-exactly-one-root-element" },
    [
      _c("header-profil", {
        attrs: { profil: _vm.profil },
        on: { updateProfil: _vm.emitUpdateProfil }
      }),
      _vm._v(" "),
      _c("main", { staticClass: "profileDashboard" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "row" },
            [
              _c("menu-profil", {
                attrs: { profil: _vm.profil, spravy: _vm.spravy }
              }),
              _vm._v(" "),
              _vm.profil.pouzivatel_id
                ? _c(
                    "div",
                    { staticClass: "col-xs-12 col-md-12 col-lg-12 col-xl-9" },
                    [
                      _c("h2", [_vm._v("Moja aktivita")]),
                      _vm._v(" "),
                      _vm.responseText != ""
                        ? _c(
                            "div",
                            {
                              class: "alert alert-" + _vm.responseType,
                              attrs: { role: "alert" }
                            },
                            [
                              _c("span", {
                                class: "icon --" + _vm.responseType
                              }),
                              _vm._v(
                                _vm._s(_vm.responseText) +
                                  "\n                    "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "o-activity__list" },
                        _vm._l(_vm.aktivita, function(zaznam, index) {
                          return _c(
                            "div",
                            { staticClass: "m-activity__item" },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 col-sm-12 col-md-3 col-lg-2 a-activity__date"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        zaznam.created_at
                                          .replace(/-/g, ".")
                                          .replace(/:..$/g, "")
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 col-sm-12 col-md-9 col-lg-10"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(zaznam.pouzivatel_log_message)
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }